import React from "react";

import AboutPart from "./AboutSection";
import Testimonial from "./TestimonialSection";
import Feature from "./FeatureSection";
import Instructor from "./InstructorSection";

const AboutMain = () => {
  return (
    <>
      <AboutPart />

      <Feature />

      <Instructor />

      <Testimonial />
    </>
  );
};

export default AboutMain;
